import { render } from "./UiAdressenReadOnly.pug?vue&type=template&id=de33091a&lang=pug"
import script from "./UiAdressenReadOnly.js?vue&type=script&lang=js"
export * from "./UiAdressenReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__